import { DiscoveryProfile } from "src/shared/contexts/ProfileContext";
import {
  convertToFileAnswers,
  HackerAPIFile,
} from "src/shared/utils/hackerapi";

import { ProfileFormValues } from "./types";

const EMPTY_PROFILE_FORM_VALUES: ProfileFormValues = {
  name: null,
  pronouns: null,
  profile_photo: null,
  profile_photo_caption: null,
  bio_prompt: null,
  bio: null,
  interests: null,
  experience_goals: null,
  weekend_pace: null,
  skills: null,
  teammates_needed: null,
  teammate_criteria: null,
  teammates_claim_ids: null,
  contact_discord: null,
  contact_linkedin: null,
  contact_x: null,
};

export const buildProfileFormValues = (
  profile: DiscoveryProfile | null
): ProfileFormValues => {
  if (!profile) return { ...EMPTY_PROFILE_FORM_VALUES };

  const photo: unknown = profile.profile_photo;
  let profilePhoto: ProfileFormValues["profile_photo"] = null;

  if (Array.isArray(photo) && photo.length > 0) {
    profilePhoto =
      typeof photo[0] === "number"
        ? (photo as number[]).map((id) => ({ id } as HackerAPIFile))
        : (photo as HackerAPIFile[]);
  } else if (photo != null && typeof photo === "object") {
    profilePhoto = [photo as HackerAPIFile];
  }

  // Explicitly map editable fields so deprecated or future backend answers
  // cannot leak into profile-update variables.
  return {
    name: profile.name,
    pronouns: profile.pronouns,
    profile_photo: profilePhoto,
    profile_photo_caption: profile.profile_photo_caption,
    bio_prompt: profile.bio_prompt,
    bio: profile.bio,
    interests: profile.interests,
    experience_goals: profile.experience_goals,
    weekend_pace: profile.weekend_pace,
    skills: profile.skills,
    teammates_needed: profile.teammates_needed,
    teammate_criteria: profile.teammate_criteria,
    teammates_claim_ids: profile.teammates_claim_ids,
    contact_discord: profile.contact_discord,
    contact_linkedin: profile.contact_linkedin,
    contact_x: profile.contact_x,
  };
};

export const buildDiscoveryProfileMutationValues = (
  values: ProfileFormValues
) => {
  const { profile_photo, skills, ...rest } = values;
  const photoIds = convertToFileAnswers(profile_photo ?? undefined);
  return {
    ...rest,
    // Omit empty photo so upsert keeps the existing file instead of clearing it.
    profile_photo: photoIds.length > 0 ? photoIds : null,
    skills: skills?.map((skill) => skill.trim()).filter(Boolean) ?? null,
  };
};
